(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-card-metafield-badges"] && !Shopify.designMode) return;
  try {
    (function () {
    var ROW_TOP_TOLERANCE = 3;

    function moveBadgesIntoGallery(root) {
      (root || document).querySelectorAll('product-card').forEach(function (card) {
        var badges = card.querySelector('.product-card-metafield-badges');
        var gallery = card.querySelector('.card-gallery');
        if (badges && gallery && !gallery.contains(badges)) {
          gallery.insertBefore(badges, gallery.firstChild);
        }
      });
    }

    /**
     * Determine whether a badge container is absolutely positioned (top/bottom
     * variants that overlay the image) or in normal flow (bottom-left with
     * position:unset).  For in-flow badges we only need minHeight on the badge
     * container itself; for absolutely-positioned ones we also need paddingTop
     * on the gallery so the image isn't hidden underneath them.
     */
    function isAbsolutelyPositioned(badgesEl) {
      var pos = window.getComputedStyle(badgesEl).position;
      return pos === 'absolute' || pos === 'fixed';
    }

    function alignBadgeHeightsByRow(root) {
      var container = root || document;
      var grids = container.querySelectorAll('.product-grid');

      grids.forEach(function (grid) {
        var items = grid.querySelectorAll('.product-grid__item');
        if (items.length === 0) return;

        // Collect all cards that have both badges and a gallery
        var itemsWithBadges = [];
        items.forEach(function (item) {
          var card = item.querySelector('product-card');
          var badges = card && card.querySelector('.product-card-metafield-badges');
          var gallery = card && card.querySelector('.card-gallery');
          if (badges && gallery) {
            itemsWithBadges.push({ item: item, badges: badges, gallery: gallery });
          }
        });

        if (itemsWithBadges.length === 0) return;

        // Reset previous adjustments so we measure natural heights
        itemsWithBadges.forEach(function (o) {
          o.badges.style.minHeight = '';
          o.gallery.style.paddingTop = '';
        });

        // Group items into visual rows by their top offset
        var topToItems = {};
        itemsWithBadges.forEach(function (o) {
          var top = Math.round(o.item.getBoundingClientRect().top);
          if (!topToItems[top]) topToItems[top] = [];
          topToItems[top].push(o);
        });

        var tops = Object.keys(topToItems).map(Number).sort(function (a, b) { return a - b; });
        var rows = [];
        var currentRow = topToItems[tops[0]].slice();
        var currentTop = tops[0];

        for (var i = 1; i < tops.length; i++) {
          if (tops[i] - currentTop <= ROW_TOP_TOLERANCE) {
            currentRow = currentRow.concat(topToItems[tops[i]]);
          } else {
            rows.push(currentRow);
            currentRow = topToItems[tops[i]].slice();
            currentTop = tops[i];
          }
        }
        rows.push(currentRow);

        // For each row, equalise badge container heights
        rows.forEach(function (row) {
          // Find the tallest badge container in this row
          var maxHeight = 0;
          row.forEach(function (o) {
            var h = o.badges.getBoundingClientRect().height;
            if (h > maxHeight) maxHeight = h;
          });
          if (maxHeight <= 0) return;

          row.forEach(function (o) {
            // Always set minHeight so shorter badge sets grow to match the tallest
            o.badges.style.minHeight = maxHeight + 'px';

            // Only adjust gallery paddingTop for absolutely-positioned badges
            // (top-left / top-right).  In-flow badges (bottom-left with
            // position:unset) already occupy space in the normal flow, so
            // adding paddingTop would double-count and push the image down too far.
            if (isAbsolutelyPositioned(o.badges)) {
              var inset = 8;
              try {
                var ins = window.getComputedStyle(o.badges).getPropertyValue('--metafield-badge-inset');
                if (ins) inset = parseInt(ins, 10) || 8;
              } catch (e) {}
              o.gallery.style.paddingTop = (maxHeight + 2 * inset) + 'px';
            }
          });
        });
      });
    }

    function run(root) {
      moveBadgesIntoGallery(root);
      requestAnimationFrame(function () {
        alignBadgeHeightsByRow(root);
      });
    }

    function runFull() { run(); }

    // Run on DOMContentLoaded …
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runFull);
    } else {
      runFull();
    }

    // … and again once all images (including badge images) have loaded,
    // because image dimensions affect badge container height.
    window.addEventListener('load', function () {
      alignBadgeHeightsByRow();
    });

    // Debounced resize handler
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        alignBadgeHeightsByRow();
      }, 100);
    });

    document.addEventListener('shopify:section:load', function (e) {
      run(e.target);
    });

    document.addEventListener('shopify:block:select', function () {
      requestAnimationFrame(function () { alignBadgeHeightsByRow(); });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
